export const SubmitReportIssueTypes = {
  projects: "Projects",
  financialReporting: "FinancialReporting",
  assetQuestionnaire: "AssetQuestionnaire",
  riskQuestionnaire: "RiskQuestionnaire",
};
